import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2613691020/src/next-app/app/(authenticated)/client.tsx");
